import React from 'react';
import { HiPaintBrush, HiDevicePhoneMobile, HiRocketLaunch, HiClock, HiArrowPath, HiShieldCheck } from 'react-icons/hi2';
import { useScrollReveal } from '../utils/useScrollReveal';
import './Features.css';

const FEATURES = [
  {
    icon: <HiPaintBrush />,
    title: 'Pixel-Perfect Design',
    description: 'Every screenshot is crafted to match Apple and Google\'s latest guidelines. No templates — fully custom work.',
  },
  {
    icon: <HiDevicePhoneMobile />,
    title: 'All Platforms Covered',
    description: 'iPhone, iPad, Android phones & tablets. Every screen size and device frame, always up to date.',
  },
  {
    icon: <HiRocketLaunch />,
    title: 'Conversion Optimized',
    description: 'We study what makes users tap "Get". Strategic layouts, compelling copy, and proven visual hierarchy that took one client from 8% to 67.8% conversion.',
  },
  {
    icon: <HiClock />,
    title: '24-48h Turnaround',
    description: 'No waiting weeks. Get your screenshots delivered fast so you can ship your app on schedule.',
  },
  {
    icon: <HiArrowPath />,
    title: 'Unlimited Revisions',
    description: 'Not happy? We\'ll revise until it\'s perfect. Your satisfaction is our priority on every project.',
  },
  {
    icon: <HiShieldCheck />,
    title: 'Store Compliant',
    description: 'Screenshots that meet all App Store and Play Store requirements. No rejections, guaranteed.',
  },
];

const STEPS = [
  { number: '01', title: 'Share Your App', description: 'Send us your app details, brand guidelines, and any specific requirements.' },
  { number: '02', title: 'We Design', description: 'Our team creates stunning, conversion-focused screenshots for your target platforms.' },
  { number: '03', title: 'Review & Refine', description: 'Review the designs and request any changes. Unlimited revisions included.' },
  { number: '04', title: 'Upload & Grow', description: 'Get your final files, upload to the store, and watch your downloads increase.' },
];

export default function Features() {
  const [headerRef, headerVisible] = useScrollReveal();
  const [gridRef, gridVisible] = useScrollReveal();
  const [stepsHeaderRef, stepsHeaderVisible] = useScrollReveal();
  const [stepsGridRef, stepsGridVisible] = useScrollReveal();

  return (
    <section className="features section" id="features">
      <div className="container">
        <div ref={headerRef} className={`features__header reveal ${headerVisible ? 'is-revealed' : ''}`}>
          <span className="section-label">Why StoreShot</span>
          <h2 className="section-title">Screenshots Built<br />to Convert</h2>
          <p className="section-subtitle">We're not a generic design agency. We only do one thing — and we do it really well.</p>
        </div>

        <div ref={gridRef} className={`features__grid reveal-stagger ${gridVisible ? 'is-revealed' : ''}`}>
          {FEATURES.map((feature, i) => (
            <div className="feature-card" key={i}>
              <div className="feature-card__icon">{feature.icon}</div>
              <h3 className="feature-card__title">{feature.title}</h3>
              <p className="feature-card__description">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* How It Works */}
        <div className="features__steps">
          <div ref={stepsHeaderRef} className={`features__steps-header reveal ${stepsHeaderVisible ? 'is-revealed' : ''}`}>
            <span className="section-label">How It Works</span>
            <h2 className="section-title">Four Simple Steps</h2>
          </div>

          <div ref={stepsGridRef} className={`features__steps-grid reveal-stagger ${stepsGridVisible ? 'is-revealed' : ''}`}>
            {STEPS.map((step, i) => (
              <div className="step-card" key={i}>
                <span className="step-card__number">{step.number}</span>
                <h3 className="step-card__title">{step.title}</h3>
                <p className="step-card__description">{step.description}</p>
                {i < STEPS.length - 1 && <div className="step-card__connector"></div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
